
import Button, { ButtonProps } from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React from 'react';

import ArrowDownIcon from '../../icons/imaterial/arrows/Arrow Down.svg';
import theme from '../../theme/theme';

type SortOptions = 'offer_price_desc' | 'offer_price_asc';

interface Props extends ButtonProps {
  handleSortClick: React.MouseEventHandler<HTMLButtonElement>;
  handleSortClose: () => void;
  optionSetter: (string: SortOptions) => void;
  open: boolean;
  anchorEl: null | HTMLElement;
  style?: React.CSSProperties;
  className?: string;
}

const SortButton: React.FC<Props> = (props) => {
  const { handleSortClick, handleSortClose, optionSetter, open, anchorEl, style, className } = props;

  return (
    <>
      <Button
        size="small"
        variant="text"
        color="secondary"
        style={style}
        className={className}
        onClick={(e) => handleSortClick(e)}
      >
        Sort results
        <ArrowDownIcon style={{ height: 12, marginLeft: theme.spacing(1.5) }} />
      </Button>
      <Menu
        open={open}
        anchorEl={anchorEl}
        onClose={handleSortClose}
      >
        <MenuItem
          onClick={() => {
            optionSetter('offer_price_desc');
            handleSortClose();
          }}
        >
          Price: High to Low
        </MenuItem>
        <MenuItem
          onClick={() => {
            optionSetter('offer_price_asc');
            handleSortClose();
          }}
        >
          Price: Low to High
        </MenuItem>
      </Menu>
    </>
  );
};

export default SortButton;
